// import React from "react";
// import { BrowserRouter } from "react-router-dom";
// import ReactDOM from "react-dom/client";
// import { Provider } from "react-redux";
// import { PersistGate } from "redux-persist/integration/react";
// import { DndProvider } from "react-dnd";
// import { HTML5Backend } from "react-dnd-html5-backend";
// import "bootstrap/dist/css/bootstrap.min.css";
// import App from "./App";
// import { store, persistor } from "./redux/store/store";
// // import reportWebVitals from './reportWebVitals';
// import "./index.scss";
// import { injectStore } from "./utils/axiosInstance";

// injectStore(store);
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   // <React.StrictMode>
//   <Provider store={store}>
//     <PersistGate loading={null} persistor={persistor}>
//       <BrowserRouter>
//         <DndProvider backend={HTML5Backend}>
//           <App />
//         </DndProvider>
//       </BrowserRouter>
//     </PersistGate>
//   </Provider>
//   // </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals();


import("./bootstrap");